export default __webpack_public_path__ + "static/Wherepeoplegotobarstodrinkmilk-c9cf0366e879841ad761249a9f44c380.jpg";